@if (showDropArea) {
  <div
    class="file-drop"
    @fadeInOut
    [ngClass]="'file-drop--' + variant"
    (dragleave)="handleDragLeave($event)"
    (dragover)="handleDragOver($event)"
    (drop)="handleDrop($event)"
  >
    @if (variant != 'plain') {
      @if (warning == null) {
        <div class="file-drop__container">
          <div class="file-drop__icon">
            <div class="file"><i class="far fa-file"></i></div>
            <div class="plus"><i class="far fa-plus"></i></div>
          </div>
          <div class="file-drop__title">
            <span
              *portalTransclusion="
                transclusions;
                name: 'title';
                context: { action: hasFile ? 'change' : 'add' }
              "
            >
              {{ 'common.file.' + (hasFile ? 'change' : 'add') | translate }}
            </span>
          </div>
        </div>
      }
      @if (warning) {
        <ngb-alert @fadeInOut [dismissible]="false" type="warning">
          {{ 'common.file.warning.' + warning | translate }}
        </ngb-alert>
      }
    }
  </div>
}
